module.exports = __webpack_public_path__ + "img/avatar1.2a6680ac.png";